
import { Button } from "@/components/ui/button";

export const Footer = () => {
  return (
    <footer className="w-full py-6 px-4 mt-auto border-t border-gray-200 bg-white">
      <div className="container mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex flex-col items-center sm:items-start gap-2">
          <div className="text-sm text-gray-600">
            © {new Date().getFullYear()} doozy by bytehype. All rights reserved.
          </div>
          <div className="flex flex-wrap justify-center sm:justify-start gap-2">
            <div className="text-sm text-black">★★★★★</div>
            <span className="text-sm text-gray-600">4.9/5 from 200+ reviews</span>
          </div>
        </div>
        <div className="flex flex-wrap items-center justify-center sm:justify-end gap-2">
          <Button
            variant="ghost"
            className="hover:bg-gray-100 transition-colors text-sm text-gray-700"
            onClick={() => window.open('https://bytehype.com.au', '_blank')}
          >
            bytehype
          </Button>
          <Button
            variant="ghost"
            className="hover:bg-gray-100 transition-colors text-sm text-gray-700"
            onClick={() => window.open('https://booom.one', '_blank')}
          >
            booom
          </Button>
          <Button
            variant="ghost"
            className="hover:bg-gray-100 transition-colors text-sm text-gray-700"
            onClick={() => window.open('https://heyhalo.site', '_blank')}
          >
            heyhalo
          </Button>
          <Button
            variant="ghost"
            className="hover:bg-gray-100 transition-colors text-sm text-gray-700"
            onClick={() => window.open('https://wnston.online', '_blank')}
          >
            wnston
          </Button>
        </div>
      </div>
    </footer>
  );
};
